module.exports = __webpack_public_path__ + "img/resources.f1f0dc6b.png";